import { render, staticRenderFns } from "./projecttwo.vue?vue&type=template&id=019c5274&scoped=true&"
import script from "./projecttwo.vue?vue&type=script&lang=js&"
export * from "./projecttwo.vue?vue&type=script&lang=js&"
import style0 from "./projecttwo.vue?vue&type=style&index=0&id=019c5274&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "019c5274",
  null
  
)

export default component.exports